import React from 'react';
import { Modal, Input, Button, FormControl, ButtonGroup } from '@landr/maestro';
import { Trans, t } from '@lingui/macro';
import { Collection } from 'types';
import { useCollectionModalEffects } from 'modals/CollectionModal/useCollectionModalEffects.hook';
import { ModalsEnum } from 'types/enums';
import { ModalProps } from '../Modal.types';

export enum ActionTypes {
    Edit = 'edit',
    Create = 'create',
}

export const CollectionModalContent: React.FC<CollectionModalProps> = ({
    collection,
    handleClose,
    isOpen,
    placeholder,
    sampleIds,
    submitButtonText,
    title,
}) => {
    const {
        value,
        error,
        isDisabled,
        handleChange,
        handleClick,
        handleSubmit,
        loading,
    } = useCollectionModalEffects({
        collection,
        isOpen,
        placeholder,
        handleClose,
        sampleIds,
    });

    return (
        <>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Content>
                <Modal.Section>
                    <form onSubmit={handleSubmit}>
                        <FormControl isInvalid={!!error}>
                            <FormControl.Label htmlFor="create-collection">
                                <Trans>Collection name</Trans>
                            </FormControl.Label>
                            <Input
                                placeholder={t`Name`}
                                onChange={handleChange}
                                value={value}
                            />
                            <FormControl.ValidationMessage>
                                {error}
                            </FormControl.ValidationMessage>
                        </FormControl>
                    </form>
                </Modal.Section>
            </Modal.Content>
            <Modal.Footer>
                <ButtonGroup>
                    <Button
                        kind="minimal"
                        variant="secondary"
                        onClick={handleClose as () => void}
                    >
                        <Trans>Cancel</Trans>
                    </Button>
                    <Button
                        isDisabled={isDisabled}
                        onClick={handleClick}
                        isLoading={loading}
                    >
                        {submitButtonText}
                    </Button>
                </ButtonGroup>
            </Modal.Footer>
        </>
    );
};

export interface CollectionModalProps extends ModalProps {
    modalType: ModalsEnum;
    title: string;
    collection?: Collection | null;
    submitButtonText: string;
    placeholder?: string | null;
    sampleIds?: Array<string>;
}

export const CollectionModal: React.FC<CollectionModalProps> = (props) => {
    const { isOpen, handleClose } = props;

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <CollectionModalContent {...props} />
        </Modal>
    );
};

export default React.memo(CollectionModal);
